module.exports = __webpack_public_path__ + "img/photo-man-whiteboard.ef5253fd.jpg";